import { render, staticRenderFns } from "./harmonyPrivacy.vue?vue&type=template&id=1314c31c&"
import script from "./harmonyPrivacy.vue?vue&type=script&lang=js&"
export * from "./harmonyPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./harmonyPrivacy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports